export default __webpack_public_path__ + "static/media/group-6.6f01517d.png";